var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.8,39.7c-0.5,0.1-1.1,0.7-1.7,0.7c-0.6,0-0.7-0.6-1.8-0.6c-0.7,0-6.3,3-9.6,2.8c-2.3-0.1-3.5-1-3.5-1 s0.1,0.7,1.4,1.1c0.8,0.2,2.4,0.6,5.1,0.6c2,0,3.7,0.9,7.6,1s6.3-2,6.6-2.3c0.4-0.3,1.2-0.7,1.7-1c0.5-0.3,0.6-0.6,0.6-0.6 s-0.6,0.2-2.1,0.3C47.7,41.1,45.3,39.7,44.8,39.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.4,28.5c-3.8-0.1-4.8,2.3-4.8,3.1c0,0.2,0,0.7,0,0.7l0.9-0.1c0-0.2,0-0.5,0-0.6c0-0.6,0.8-2.3,3.9-2.3 c3.5,0.1,3.6,3.1,3.6,3.1c0,0.6-0.3,1.4-0.3,1.4l0.4,0.2l0.4,0.2c0,0,0.5-1,0.4-1.8C36.9,31.5,36,28.6,32.4,28.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,28.4C48.4,28.4,48.4,28.4,48.4,28.4c-1.9,0-2.8,0.8-3.4,1.5c-0.9,1.2-0.9,2.9-0.6,3.9l0.9-0.3 c-0.2-0.8-0.3-2.1,0.5-3.1c0.6-0.7,1.4-1.1,2.6-1.1c0,0,0,0,0,0c1.1,0,1.9,0.3,2.3,1c0.4,0.6,0.5,1.3,0.4,1.6l0.9,0.3 c0.2-0.6,0.1-1.6-0.5-2.5C51,29.1,50.1,28.4,48.4,28.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.2,30.1c-1.7,0-2.1,1.6-2.2,1.8c0,0.1,0,0.5,0,0.5s1.2,0.1,2.4,0.3c1.2,0.3,1.9,0.7,1.9,0.7s0.3-0.5,0.3-1 C34.6,32.1,34.5,30.1,32.2,30.1z M31.6,31.4c-0.2,0.2-0.4,0.2-0.6,0.1c-0.2-0.2-0.2-0.4-0.1-0.6s0.4-0.2,0.6-0.1 C31.8,30.9,31.8,31.2,31.6,31.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.8,30c-1.9,0-2.1,1.6-2.1,2c0,0.5,0.3,1.1,0.3,1.1s1-0.3,1.9-0.6c0.9-0.3,2-0.4,2-0.4S50.3,30,47.8,30z  M47.1,31.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C47.6,31.3,47.4,31.5,47.1,31.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.3,23.1c-9.1,0-12.7,7.3-12.3,7.7c0.4,0.3,0.9,0.2,2.7-1.8c1.2-1.3,4.8-3.4,9-3.4s6.8,2.6,6.8,2.6 s0.3-0.7,0.5-1.5c0.2-0.7,0.2-1.9,0.2-1.9S37.8,23.1,32.3,23.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.8,17.3c-1.8-1.6-5.1-4.3-8-5.6c-2.9-1.4-6.9-3.4-7.9-3.5c-1,0-10.3,3.1-14.1,5.3 c-2.6,1.5-8.8,5.9-13.1,11.6c-1.7,2.3-2.9,4.4-2.7,6.3c0.3,1.9,2,5.3,3.1,6.9c0.8,1.2,1.8,1.9,2.4,2.1c-0.2,0.7-0.6,1.2-1,1.7 c-0.7,0.9-1.6,1.9-1.4,3.7c0,0.3,0.1,0.6,0.2,0.9c-0.3,0.4-0.6,0.9-0.6,1.6c0,1.9,1.6,2.5,2.5,2.5c0.9,0,2.1-0.6,2.2-2.4 c0.2-0.1,0.4-0.2,0.6-0.4c0.2,0.6,0.6,1.3,1,2c1.4,2.5,3.8,4.3,7.1,5.4c0.1,0.1,0.2,0.2,0.2,0.2s0.1,0,0.2,0 c0.4,0.1,0.9,0.2,1.3,0.3c0.1,0,0.2,0,0.3,0.1c0.3,0.2,0.6,0.4,0.6,0.4l0-0.3c0.2,0,0.5,0,0.8,0l1.1,0.6l0.1-0.6c0.2,0,0.4,0,0.6,0 c0.3,0.1,0.6,0.3,0.8,0.4c0.8,0.3,1.9,0.4,3.2,1.1c1.5,0.8,1.8,2.3,3.1,3.4s5,1.5,6.3,2.6c0.5,0.4,1,1.8,1,1.8s0.6-1.7,0.6-2.8 c0-1-1.5-2.9-1.6-3.3s0.6-1.7,1.1-2c0.5-0.3,1.6-0.2,1.6-0.2s0.8-1.1,1-1.2c0.3-0.1,0.6,0,0.6,0l0.5-1l0.3,0.4c0,0,0.4-0.2,0.6-0.6 c0.2-0.3,0.6-0.9,0.9-1.3c0.3-0.1,0.6-0.2,0.8-0.4c3-1.8,5.1-6.1,6-11.8c0.6-4.3-1.7-7.1-2.9-8.3c1.2-1.1,3.2-3.6,3.4-7.8 C57.9,20,57.4,19.6,54.8,17.3z M14.2,50c-1,0-1.6-0.7-1.6-1.6c0-0.2,0.1-0.5,0.2-0.7c0.4,0.6,1.1,1.1,2.1,1.2c0.1,0,0.2,0,0.3,0 c0.1,0,0.3,0,0.4,0C15.3,49.2,15,50,14.2,50z M17.1,38.3c0,0.1,0,0.2,0,0.3c-0.1,1.1-0.4,2-0.6,2.7c-0.1,0.5-0.2,0.9-0.3,1.3l0,0.1 c-0.1,0.8-0.3,2.1,0.1,3.8c-0.2,0.3-0.8,0.9-1.5,0.8c-0.6-0.1-1-0.4-1.2-0.8c0.1,0,0.2,0,0.2,0c0.5,0,0.7,0,0.7-0.2 c0-0.4-0.6-0.5-0.9-0.5c-0.1,0-0.2,0-0.3,0.1c0-0.1,0-0.1,0-0.2c-0.1-1.3,0.4-1.9,1.1-2.7c0.7-0.8,1.5-1.7,1.5-3.3 c0-1.4-0.7-3-1.4-4.5c-0.4-0.9-0.8-1.7-0.9-2.3c-0.2-1,0-1.9,0.6-2.5c0.4-0.5,1.1-0.7,1.8-0.7c0.4,0,0.8,0.3,1.1,0.5 c-0.1,0.4-0.1,0.9-0.1,1.4c-0.1-0.1-0.3-0.1-0.5-0.1c-0.7,0.1-1.4,0.2-1.4,1.9C15.2,35.2,17.1,37.8,17.1,38.3z M52.2,45.6 c0,0-0.2,0.7-0.6,1.4c-0.5,0.7-1,1.5-3.9,1.8c-3,0.3-5.4-1.2-5.4-1.2s-3.5,1.9-4.8,2.4c-1.3,0.5-4.1,0.4-4.1,0.4l0.3-0.7 c0,0-2.5,0.7-3.6,0.4c-1.1-0.3-5.3-2.4-5.4-6.6c-0.2-4.1,3.8-6.2,3.8-6.2v0.6c0,0,0.3,0,0.8-0.3c0.5-0.3,1.7-0.6,1.7-0.6l-0.4,1.2 c0,0,4.4-1.9,5.7-1.9c0.8,0,1.8,0.1,2.3,0.2c0.2,0.2,0.5,0.3,0.8,0.3c0.6,0.1,1.1-0.1,1.1-0.1s0.4,0.8,2.3,0.8c1,0,1.6-0.5,1.9-0.9 c0.5-0.2,1.9-0.7,3.7-0.7c3.2-0.1,3.6,2.9,3.7,3.8c0.1,1-0.4,2.7-0.4,2.7l0.6-0.3c0,0,0.1,0.6-0.1,1.3c-0.2,0.7-0.7,2.2-0.7,2.2 L52.2,45.6z M55.7,41.1c-0.5,3.8-1.8,7-3.4,9.1c0.6-1.6,1.4-3.8,1.7-4.3c0.5-0.7,0.5-0.4,0.5-0.4s0.2-4.2,0.2-5.1 c0-1.8-1.2-3.2-1.2-3.2l0.9,0c0,0-1.7-3.1-4.8-3.2c-1.5-0.1-2.8,0.6-3.7,1.3c0.1-0.4-0.1-0.8-0.1-0.9c-0.2-0.4-0.7-0.8-0.8-0.6 c-0.2,0.2,0.5,0.3,0.5,0.9c0,0.6-0.5,0.6-0.5,0.6s0,0-0.2-0.5c-0.2-0.4-0.9-0.9-1-0.7c-0.2,0.2,0.5,0.8,0.5,1.2 c0.1,0.5,0.4,1.2-1.5,1.4c-2.3,0.2-1.4-2.1-1.8-2.2c-0.4-0.1-0.6,0.6-0.7,1.2C40,35.9,40,35.9,40,35.9s-0.7,0.4-1.2-0.4 c-0.4-0.5,0-1.2-0.2-1.3c-0.2-0.1-0.7,0.6-0.6,1.5c0,0.3,0.1,0.5,0.3,0.7c-1.3-0.5-4.1-1.5-5.9-1.7c-2.5-0.3-4.5,0-8.2,2.2 c-3.6,2.1-3.9,8-2.9,12.3c0.4,1.7,1,3,1.7,4c-1.7-0.9-3-2.2-3.9-3.8c-1.9-3.3-1.6-5.3-1.4-6.4l0-0.1c0-0.3,0.1-0.7,0.3-1.2 c0.3-1.2,0.8-2.9,0.7-5.3c0-0.5-0.1-1.2-0.1-1.8c-0.1-1.9-0.3-4.4,0.5-5.4c0.1-0.1,0.3-0.3,0.4-0.6c1.8-2.4,7.2-9.7,21.2-9.2 c5.4,0.2,9.1,1.5,11.1,3.8c0.5,0.7,0.9,1.4,1.2,2.1c-0.2-0.3-0.5-0.6-0.8-0.8c-0.4-0.3-1.4-1.2-4.1-1.3c-3.2-0.1-4.6,1.8-4.6,1.8 s0,0.6,0.1,1.4C43.6,27.1,44,28,44,28c1.3-0.4,1.2-2.9,4.9-2.9c2.5,0,3.8,1.3,4.4,2.1c0.1,1,0,2-0.1,2.9c-0.1,1.1-0.7,2.7-0.7,2.7 l-0.2,0.5l0.4,0.3C52.8,33.6,56.4,36.3,55.7,41.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.7,12.6c2.2-1.3,9.6-4.1,9.6-4.1s-0.6-0.3-6.6,0.2c-4.5,0.4-7.7,1-12,2.2c-1.9,0.5-3.1,1.6-3.6,2.5 c-0.4,0.9-2.4,5.8-2.7,8.9c-0.3,3.1,0.5,4.3,0.5,4.3s2.2-3.1,4.6-5.5C15.5,18.9,20.2,14.6,23.7,12.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.1,8.5c0,0,6.3,2.7,9.2,5c2.9,2.4,5,4.4,5,4.4s0.3-1.1,0-2.7s-1.6-5.1-2.2-5.9c-0.6-0.8-1.4-1.2-3.7-1.3 C48.3,7.9,43.1,8.5,43.1,8.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 42.831,
    cy: 6.1475,
    r: 60.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.982887e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.2,7C34,7,36.3,7.5,36.3,7.5s1.8-0.6,2.5-0.6c0.6,0,1.7,0.5,1.7,0.5s3.7-0.4,5.7-0.5c2-0.1,4.7-0.2,4.7-0.2 s-3.7-3.2-6.2-4.2c-2.4-1.1-4.6-1.9-7.1-1.8c-2.5,0.1-7.6,0.6-12,1.7s-7,2.2-7.8,3c-0.8,0.8-2.2,2.5-2.5,3.1 c-0.3,0.6-0.6,1.1-0.6,1.1s2.4-0.8,5.6-1.3C23.3,7.7,28.4,7.1,31.2,7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo-grey.3f16ae7886c9c9b89452069348808150.svg";
export { ForwardRef as ReactComponent };